export default "__VITE_ASSET__B8f9z0kJ__"